

document.addEventListener("DOMContentLoaded", function () {
  const $mainSlider = $('.product-main-slider.slider-enabled');

  if ($mainSlider.length > 0) {
    // Init main slider
    $mainSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      dots: false,
      prevArrow: '<button type="button" class="custom-arrow slick-prev">&#10094;</button>',
      nextArrow: '<button type="button" class="custom-arrow slick-next">&#10095;</button>',
      responsive: [
        {
          breakpoint: 749,
          settings: {
            dots: true,
            arrows: false
          }
        }
      ]
    });

  
      // Find den main-slide der hoerer til en miniature ud fra media-id.
      // data-index kan IKKE bruges: Liquid taeller miniaturerne fra 1, mens
      // slidesene taeller fra 0, saa paa produkter hvor varianterne ikke har et
      // tilknyttet billede peger hver miniature paa det naeste billede.
      function mainSlides() {
        return $("#MainSlider .main-slide").not(".slick-cloned");
      }

      function slideIndexForMediaId(mediaId) {
        if (!mediaId) return -1;
        const slides = mainSlides();
        return slides.index(slides.filter('[data-media-id="' + mediaId + '"]').first());
      }

      function setActiveThumb(index) {
        const mediaId = mainSlides().eq(index).attr("data-media-id");
        $("#ThumbSlider .thumb-slide").removeClass("active");
        if (mediaId) {
          $('#ThumbSlider .thumb-slide[data-media-id="' + mediaId + '"]').addClass("active");
        } else {
          $('#ThumbSlider .thumb-slide[data-index="' + index + '"]').addClass("active");
        }
      }

      setActiveThumb($mainSlider.slick("slickCurrentSlide") || 0);

      // Thumbnail click
      $(document).on("click", "#ThumbSlider .thumb-slide", function () {
        const $thumb = $(this);
        let targetIndex = slideIndexForMediaId($thumb.attr("data-media-id"));
        if (targetIndex < 0) targetIndex = parseInt($thumb.attr("data-index"), 10);
        if (isNaN(targetIndex) || targetIndex < 0) return;

        $mainSlider.slick("slickGoTo", targetIndex);
        setActiveThumb(targetIndex);
      });

      // Sync when main slider changes (arrows/dots/swipe)
      $mainSlider.on("afterChange", function (event, slick, currentSlide) {
        setActiveThumb(currentSlide);
      });
  }
});

$(".Click-here").on('click', function() {
  $(".custom-model-main").addClass('model-open');
}); 
$(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
});





// Helper to get main slider
function getMainSlider() {
  const sliderEl = document.querySelector("#MainSlider.slider-enabled");
  return sliderEl ? $(sliderEl) : null;
}

// Sync main image and thumbs by variant ID
function updateImageByVariantId(variantId) {
  if (!variantId) return;

  let mediaId = null;

  // First try to find a thumb with exact single variant match
  document.querySelectorAll('#ThumbSlider .thumb-slide').forEach(slide => {
    const singleId = slide.dataset.variantId?.trim();
    if (singleId === variantId) {
      mediaId = slide.dataset.mediaId;
    }
  });

  // If not found, fallback to thumbs with multiple variant IDs
  if (!mediaId) {
    document.querySelectorAll('#ThumbSlider .thumb-slide').forEach(slide => {
      const ids = (slide.dataset.variantIds || '').split(',').map(i => i.trim());
      if (ids.includes(variantId)) mediaId = slide.dataset.mediaId;
    });
  }

  if (!mediaId) return;

  const $mainSlider = $("#MainSlider.slider-enabled");
  if ($mainSlider.length) {
    const targetSlide = Array.from(document.querySelectorAll('#MainSlider .main-slide'))
                             .findIndex(s => s.dataset.mediaId === mediaId);
    if (targetSlide >= 0) $mainSlider.slick('slickGoTo', targetSlide);
  }

  // Highlight active thumb
  $('#ThumbSlider .thumb-slide').removeClass('active');
  $('#ThumbSlider .thumb-slide[data-media-id="' + mediaId + '"]').addClass('active');
}

// Watch for URL variant changes
let lastVariantId = null;
const observer = new MutationObserver(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");
  if (variantId && variantId !== lastVariantId) {
    lastVariantId = variantId;
    updateImageByVariantId(variantId);
  }
});
observer.observe(document.body, { childList: true, subtree: true });

// Initial sync on page load
document.addEventListener("DOMContentLoaded", () => {
  const variantId = new URLSearchParams(window.location.search).get("variant");
  if (variantId) updateImageByVariantId(variantId);
});


function initVariantSync() {
  const variantId = new URLSearchParams(window.location.search).get("variant");
  if (variantId) updateImageByVariantId(variantId);
}

// Retry until slider exists
const retryInit = setInterval(() => {
  if (getMainSlider()) {
    clearInterval(retryInit);
    initVariantSync();
  }
}, 200);





















